import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import Transition, { ENTERED, ENTERING } from 'react-transition-group/Transition';
const fadeStyles = {
  [ENTERING]: 'in',
  [ENTERED]: 'in'
};
class Fade extends React.Component {
  render() {
    const {
      className,
      children,
      ...props
    } = this.props;
    return /*#__PURE__*/React.createElement(Transition, props, (status, innerProps) => /*#__PURE__*/React.cloneElement(children, {
      ...innerProps,
      className: clsx('fade', className, children.props.className, fadeStyles[status])
    }));
  }
}
Fade.defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};
export default Fade;